<script>
  import { onDestroy } from "svelte";
  import { lang } from '../lib/stores';
  import {
    allWords,
    commonWords,
    baseWords,
    foundamentalWords,
  } from "../data/words.js";
  import Dots from "./Dots.svelte";

  export let ratio = 25;
  export let data = {};
  let sections = [];

  let selectedLang;
	const unsubscribe = lang.subscribe((value) => selectedLang = value);
  onDestroy(unsubscribe);

  const compute = () => {
    const ghaliWords = Number(data?.stats?.wordsWithoutForeign);
    sections = [
      {
        color: "var(--grey-0)",
        props: {
          fill: "var(--grey-0)",
          stroke: "var(--grey-0)",
          opacity: 1,
        },
        dots: 0,
        id: 1,
        text: selectedLang === 'it' ?
          `Voci del vocabolario: <em class="data">${new Intl.NumberFormat("it-IT").format(allWords)}</em> parole` :
          `Vocabulary entries: <em class="data">${new Intl.NumberFormat("en-US").format(allWords)}</em> words`,
      },
      {
        color: "var(--grey-1)",
        props: {
          fill: "var(--grey-1)",
          stroke: "var(--grey-1)",
        },
        dots: 0,
        id: 2,
        text: selectedLang === 'it' ?
          `Lessico comune: <em class="data">${new Intl.NumberFormat("it-IT").format(commonWords)}</em> parole` :
          `Common vocabulary: <em class="data">${new Intl.NumberFormat("en-US").format(commonWords)}</em> words`,
      },
      {
        color: "var(--grey-2)",
        props: {
          fill: "var(--grey-2)",
          stroke: "var(--grey-2)",
        },
        dots: 0,
        id: 3,
        text: selectedLang === 'it' ?
          `Vocabolario base: <em class="data">${new Intl.NumberFormat("it-IT").format(baseWords)}</em> parole` :
          `Base vocabulary: <em class="data">${new Intl.NumberFormat("en-US").format(baseWords)}</em> words`,
      },
      {
        color: "var(--accent-2)",
        props: {
          fill: "var(--accent-2)",
          stroke: "var(--accent-2)",
          opacity: 1,
        },
        dots: 0,
        id: 5,
        text: selectedLang === 'it' ?
          `Lessico di Ghali: <em class="data">${new Intl.NumberFormat("it-IT").format(ghaliWords)}</em> parole` :
          ` Ghali's lexicon: <em class="data">${new Intl.NumberFormat("en-US").format(ghaliWords)}</em> words`,
      },
      {
        color: "var(--grey-3)",
        props: {
          fill: "var(--grey-3)",
          stroke: "var(--grey-3)",
          opacity: 0.5,
        },
        dots: 0,
        id: 4,
        text: selectedLang === 'it' ?
          `Lessico fondamentale: <em class="data">${new Intl.NumberFormat("it-IT").format(foundamentalWords)}</em> parole` :
          `Core vocabulary: <em class="data">${new Intl.NumberFormat("it-IT").format(foundamentalWords)}</em> words`,
      },
    ];
    sections[0].dots = Math.ceil(allWords / ratio);
    sections[1].dots = Math.ceil(commonWords / ratio);
    sections[2].dots = Math.ceil(baseWords / ratio);
    sections[3].dots = Math.ceil(ghaliWords / ratio);
    sections[4].dots = Math.ceil(foundamentalWords / ratio);
  };

  $: ratio, compute();
  $: data, compute();
  $: selectedLang, compute();
</script>

<div class="words">
  {#each sections as section}
    <div class="words-chart section-{section.id}">
      <div class="dots-wrapper">
        <Dots
          dots={section.dots}
          maxDots={sections[0].dots}
          id={section.id}
          props={section.props}
        />
      </div>
      <div class="texts">
        <spn class="legend-dot" style={`background-color: ${section.color}`} />
        {@html section.text}
      </div>
    </div>
  {/each}
</div>

<style>
  .words {
    position: relative;
  }

  .legend-dot {
    background: var(--background);
    border: 1px solid var(--foreground);
    /* border-radius: 50%; */
    display: inline-block;
    height: 10px;
    vertical-align: middle;
    width: 10px;
  }

  .words-chart {
    display: block;
    height: 80vh;
    position: sticky;
    top: 10rem;
  }

  .dots-wrapper {
    display: block;
    height: 50vh;
  }

  .texts {
    display: block;
    line-height: 2rem;
    white-space: nowrap;
  }

  .section-2 .texts {
    margin-top: 2rem;
  }

  .section-3 .texts {
    margin-top: 4rem;
  }

  .section-5 .texts {
    margin-top: 6rem;
  }

  .section-4 .texts {
    margin-top: 8rem;
  }

  @media screen and (min-width: 768px) {
    .words-chart {
      display: flex;
      height: 50vh;
    }

    .dots-wrapper,
    .texts {
      flex: 0 0 50%;
    }

    .texts {
      padding-left: 2rem;
      top: 0;
    }
  }
</style>
